export enum NotificationsQuerykey {
  Me = '/notifications/me',
}
